import {
  BellOutlined,
  DollarOutlined,
  SecurityScanOutlined,
  UserOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";
import { Alert, Avatar } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useResponsive } from "../../hooks/useResponsive";
import { motion } from "framer-motion";
import useUser from "../../hooks/useUser";
import { userState } from "../../store/slices/loginSlice";
import store from "../../store/store";
import { getAuth, sendEmailVerification } from "firebase/auth";
import { useTranslation } from "react-i18next";

const ProfileCard = () => {
  const { t } = useTranslation("postAuth", {
    keyPrefix: "profile",
  });
  const [emailSent, setemailSent] = useState(false);

  const { mobileOnly } = useResponsive();
  const { uploadProfilePic, updateUser } = useUser();

  const state = store.getState().login;
  const handleFileChange = async (e) => {
    const photoURL = await uploadProfilePic(e.target.files[0], state.user.uid);
    await updateUser(state.user.uid, { photoURL });
    store.dispatch(userState({ ...state.user, photoURL }));
  };
  useEffect(() => {
    const verificationEmailSent = localStorage.getItem("verificationEmailSent");
    if (state.emailVerified) {
      setemailSent(false);
      localStorage.removeItem("verificationEmailSent");
    } else if (verificationEmailSent) {
      setemailSent(verificationEmailSent);
    }
  }, [state]);
  const sendVerificationEmail = () => {
    const auth = getAuth();
    localStorage.setItem("verificationEmailSent", true);
    setemailSent(true);
    sendEmailVerification(auth.currentUser);
  };
  return (
    <div className="flex flex-col md:flex-row justify-evenly items-center h-full mediumShadow bg-white  m-4 p-2 rounded-lg">
      <div className="flex flex-col justify-center items-center md:w-1/2 h-1/2 md:h-auto gap-4">
        {" "}
        {state?.user?.photoURL ? (
          <div className="relative">
            <Avatar
              className="flex items-center justify-center"
              size={mobileOnly ? 120 : 100}
              src={<img src={state?.user?.photoURL} alt="avatar" />}
            />
            <label htmlFor="fileUpload">
              <CloudUploadOutlined
                htmlFor="fileUpload"
                className="absolute text-2xl right-1 -bottom-0 transform active:scale-50 transition-transform duration-300 ease-in-out cursor-pointer"
              />
            </label>
            <input
              id="fileUpload"
              type="file"
              className="hidden"
              onChange={handleFileChange}
            />
          </div>
        ) : (
          <div className="relative">
            <Avatar
              className=" flex items-center justify-center "
              size={mobileOnly ? 120 : 60}
              icon={<UserOutlined />}
            />
            <label htmlFor="fileUpload">
              <CloudUploadOutlined
                htmlFor="fileUpload"
                className="absolute text-2xl right-0 -bottom-2 transform active:scale-50 transition-transform duration-300 ease-in-out"
              />
            </label>
            <input
              id="fileUpload"
              type="file"
              className="hidden"
              onChange={handleFileChange}
            />
          </div>
        )}
        <span className="flex flex-row flex-wrap justify-center items-center gap-2 m-0">
          <p className="font-normal text-base">{state?.user?.email}</p>{" "}
          {state?.user?.emailVerified ? (
            <Alert
              message="Verified"
              type="success"
              showIcon
              className="cursor-pointer shadow-md  rounded-lg "
            />
          ) : emailSent ? (
            <Alert
              message="Verification Email sent, check your inbox"
              type="info"
              showIcon
              className="cursor-pointer shadow-md  rounded-lg "
            />
          ) : (
            <motion.span
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.9 }}
              className="cursor-pointer shadow-md hover:shadow-lg rounded-lg transition-all duration-100"
              onClick={() => sendVerificationEmail()}
            >
              <Alert
                message="Email not verified, Click here to send verification email"
                type="warning"
                showIcon
              />
            </motion.span>
          )}
        </span>
      </div>
      {!mobileOnly && (
        <span className="inline-block h-auto w-0.5 self-stretch bg-primaryColor opacity-100 "></span>
      )}
      <div className="md:w-1/2 mx-8 flex flex-col items-center justify-evenly h-1/2 md:h-auto">
        <Link
          to={"personal-info"}
          className="flex gap-2 hover:bg-blue-100 focus:bg-blue-100  py-1 px-2 rounded-lg w-full items-center"
        >
          <UserOutlined className="bg-blue-200 flex justify-center items-center text-lg p-2 rounded-lg text-primaryColor" />
          <p className="font-semibold text-lg">{t("personal info")}</p>
        </Link>
        <Link
          to={"security-settings"}
          className="flex gap-2 hover:bg-blue-100 focus:bg-blue-100  py-1 px-2 rounded-lg w-full items-center"
        >
          <SecurityScanOutlined className="bg-blue-200 flex justify-center items-center text-lg p-2 rounded-lg text-green-600" />
          <p className="font-semibold text-lg">{t("security settings")}</p>
        </Link>
        <Link
          to={"notifications"}
          className="flex gap-2 hover:bg-blue-100 focus:bg-blue-100  py-1 px-2 rounded-lg w-full items-center"
        >
          <BellOutlined className="bg-blue-200 focus:bg-blue-100  flex justify-center items-center text-lg p-2 rounded-lg text-red-600" />
          <p className="font-semibold text-lg"> {t("notifications")}</p>
        </Link>
        <Link
          to={"payments"}
          className="flex gap-2 hover:bg-blue-100 focus:bg-blue-100 py-1 px-2 rounded-lg w-full items-center"
        >
          <DollarOutlined className="bg-blue-200 flex justify-center items-center text-lg p-2 rounded-lg text-yellow-500" />
          <p className="font-semibold text-lg">{t("payment")}</p>
        </Link>
      </div>
    </div>
  );
};

export default ProfileCard;
